export default {
  routeExtras: {
    extras: 'Routen-Extras',
    extraInfo: 'Zusatzinformationen',
    value: 'Wert',
    clickToHighlightOnMap: 'Klicken, um die Streckenabschnitte auf der Karte anzuzeigen',
    showAllOnMap: 'Alle auf der Karte anzeigen'
  }
}
